import { Link } from "react-router-dom";
import { ArrowUpRight, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL, TAGLINE } from "@/lib/site";

export const CtaBanner = () => (
  <section className="bg-white px-4 sm:px-6 lg:px-10 py-16 md:py-24">
    <Reveal className="mx-auto max-w-7xl">
      <div className="relative overflow-hidden rounded-[2rem] bg-[var(--green)] px-7 py-14 sm:px-14 md:py-20 text-white grain" data-testid="cta-banner">
        <div className="absolute -right-24 -bottom-24 h-80 w-80 rounded-full bg-white/10" aria-hidden="true" />
        <div className="relative grid gap-10 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-8">
            <p className="font-accent text-xl sm:text-2xl text-white/90">{TAGLINE}</p>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
              Tell us what needs doing. We'll send you a free, no-obligation quote.
            </h2>
          </div>
          <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3">
            <Link to="/quote" data-testid="cta-banner-quote-button"
              className="group inline-flex items-center justify-between gap-3 rounded-full bg-white px-7 py-4 font-semibold text-[var(--navy)] transition-transform duration-300 hover:-translate-y-0.5">
              GET A FREE QUOTE <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:rotate-45" />
            </Link>
            <a href={PHONE_TEL} data-testid="cta-banner-call-button"
              className="inline-flex items-center justify-between gap-3 rounded-full border border-white/50 px-7 py-4 font-semibold text-white transition-colors duration-300 hover:bg-white/10">
              {PHONE_DISPLAY} <Phone className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);
